<template>
  <div
    class="row mt-2"
    v-if="formularioFormaDePagamentoCliente.forma_pagamento_selecionado_padrao === 'Cartão de crédito'"
  >
    <div class="col-12 mb-3 mt-2" v-if="!desativarGerenciador && !estaCadastrandoCartao && !isLoadingCartao && !isLoading && cartoes.length != 0">
      <h3>Cartões cadastrados</h3>
    </div>
    <div class="col-12 mb-3 mt-2" v-else-if="!desativarGerenciador &&  estaCadastrandoCartao && !isLoading">
      <h3>Incluir novo cartão</h3>
    </div>
    <div class="col-12" v-if="estaCadastrandoCartao && !isLoadingCartao || cartoes.length == 0">
      <div class="row p-0 m-0">
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="required">Nome impresso no cartão</label>
            <input
              v-model="formulario.escritorio.cartao.nome_cartao"
              maxlength="25"
              class="form-control"
            />
            <div
              v-if="listaDeErros['escritorio.cartao.nome_cartao']"
              class="text-danger"
            >
              {{ listaDeErros["escritorio.cartao.nome_cartao"] }}
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="required">CPF/CNPJ</label>
            <input
              v-model="cpfCnpj"
              v-mask="mascaraDocumento(formulario.escritorio.cartao.cpf_cnpj)"
              maxlength="18"
              class="form-control campo-DocumentoCpfCnpjAlfanumericoUppercase"
            />
            <div
              v-if="listaDeErros['escritorio.cartao.cpf_cnpj']"
              class="text-danger"
            >
              {{ listaDeErros["escritorio.cartao.cpf_cnpj"] }}
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="required">Número do cartão</label>
            <div class="d-flex align-items-center position-relative">
              <input
                v-mask="'################'"
                v-model="formulario.escritorio.cartao.numero_cartao"
                @input="determinarBandeiraDoCartao"
                class="form-control"
              />
              <img
                v-if="bandeiraDoCartao"
                :src="obterBandeiraInputLocal(bandeiraDoCartao)"
                class="position-absolute"
                style="
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
                  width: 30px;
                  height: 30px;
                "
              />
            </div>
            <div
              v-if="listaDeErros['escritorio.cartao.numero_cartao']"
              class="text-danger"
            >
              {{ listaDeErros["escritorio.cartao.numero_cartao"] }}
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="required">Data Expiração</label>
            <input
              v-mask="'##/####'"
              v-model="formulario.escritorio.cartao.validade_cartao"
              class="form-control"
            />
            <div
              v-if="listaDeErros['escritorio.cartao.validade_cartao']"
              class="text-danger"
            >
              {{ listaDeErros["escritorio.cartao.validade_cartao"] }}
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="form-group">
            <label class="required">CCV</label>
            <input
              v-mask="'####'"
              v-model="formulario.escritorio.cartao.ccv_cartao"
              class="form-control"
            />
            <div
              v-if="listaDeErros['escritorio.cartao.ccv_cartao']"
              class="text-danger"
            >
              {{ listaDeErros["escritorio.cartao.ccv_cartao"] }}
            </div>
          </div>
        </div>
        <div class="col align-self-center">
          <div class="form-check" v-if="estaCadastrandoCartao && cartoes.length > 0">
            <input
              class="form-check-input"
              type="checkbox"
              id="cartaoPadrao"
              v-model="cartaoPadraoLocal"
            />
            <label class="form-check-label" for="cartaoPadrao">
              Definir como cartão padrão
            </label>
          </div>
        </div>
        <div class="col-6 text-right" v-if="!desativarGerenciador ">
          <button v-if="cartoes.length > 0"
            type="button"
            :disabled="isLoadingCartao"
            class="botoes btn btn-primary btn-sm mr-2"
            @click="cadastrarCartaoNovo(false)"
          >
            Voltar
          </button>
          <button
            type="button"
            :disabled="isLoadingCartao"
            class="botoes btn btn-primary btn-sm"
            @click="cadastrarCartao"
          >
            Salvar cartão
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
       <spinnerProcessando
        cssClass="ml-2"
        :status="isLoadingCartao"
        :mensagem="'Carregando cartões...'"
      />
    </div>
    <div
      class="col-12"
      v-if="cartoes.length > 0 && !desativarGerenciador"
    >
      <div class="row" v-if="!estaCadastrandoCartao && formularioFormaDePagamentoCliente.forma_pagamento_selecionado_padrao == 'Cartão de crédito' && cartoes.length > 0">
        <div class="col-12" v-if="apresentarDebitoAutomatico">
          <label for="debitoAutomatico">
            <input type="checkbox" id="debitoAutomatico" v-model="formularioFormaDePagamentoCliente.pagamento_automatico" />
            Débito automático (no dia do vencimento de suas mensalidades será efetuado o pagamento com o cartão padrão)
          </label>
        </div>
      </div>
      <div class="row" v-if="!estaCadastrandoCartao && !isLoadingCartao">
        <div :class="styleCartao ? styleCartao : 'col-md-4'" v-for="(cartao, index) in cartoes" :key="index">
          <div
            class="card bg-cinza clicavel textoPadrao"
            :class="{ 'border-primary': cartao.selecionado }"
            @click="selecionarCartao(index)"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="row">
                    <div class="col-12">
                      <h5 class="card-title">{{ cartao.nome }}</h5>
                    </div>
                    <div class="col-12">
                      <p class="card-text mb-2">
                        **** **** **** {{ cartao.numero }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <img height="30" width="30" :src="obterBandeiraLocal(cartao)" />
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <p class="card-text">
                        Data expiração: {{ cartao.expiracao }}
                      </p>
                    </div>
                    <div class="col-12">
                      <div >
                        <div class="row">
                          <div class="col-6 text-left">
                            <div v-if="cartao.padrao">
                              <span class="badge badge-primary">Cartão padrão</span>
                            </div>
                          </div>
                          <div class="col-6 text-right" v-if="!cartao.padrao">
                            <button
                              :disabled="isLoadingCartao || index === 0"
                              class="btn btn-sm btn-primary no-hover-btn"
                              @click="excluirCartao(cartao.id)"
                            >
                              <b>Excluir</b>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-0" v-if="!isLoadingCartao">
        <div class="col-auto text-left">
            <button class="botoes btn btn-primary btn-sm" v-if="!estaCadastrandoCartao" @click="cadastrarCartaoNovo(true)">
                Incluir cartão
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartaoPagamento from './js/cartaoPagamento'
export default CartaoPagamento
</script>

<style scoped>
@import "./scss/cartao.scss";
</style>
